import { render, staticRenderFns } from "./EHPADSecondPartComp.vue?vue&type=template&id=0401277f&scoped=true"
import script from "./EHPADSecondPartComp.vue?vue&type=script&lang=js"
export * from "./EHPADSecondPartComp.vue?vue&type=script&lang=js"
import style0 from "./EHPADSecondPartComp.vue?vue&type=style&index=0&id=0401277f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401277f",
  null
  
)

/* custom blocks */
import block0 from "./EHPADSecondPartComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports